module.exports = __webpack_public_path__ + "img/SWZ.6d08e583.svg";